import { combineReducers } from "redux";
import account from "./account/reducer";
import { reducer as toastrReducer } from "react-redux-toastr";
import port from "./port/reducer";
import connection from "./connection/reducer";
import block from "./block/reducer";
import channel from "./channel/reducer";
import user from "./user/reducer";
import monitoring from "./monitoring/reducer";
import widget from "./widget/reducer";
import widgetChannel from "./widgetChannel/reducer";
import widgetState from "./widgetState/reducer";
import history from "./history/reducer";
import dashboard from "./dashboard/reducer";
import jwt from "./jwt/reducer";
import setting from "./setting/reducer";
import tagGroup from "./tagGroup/reducer";
import session from "./session/reducer";
import credential from "./credential/reducer";
import bucket from "./bucket/reducer";
import gauge from "./gauge/reducer";
import license from "./license/reducer";
import healthCheck from "./healthCheck/reducer";
import displayProfile from "./displayProfile/reducer";
import monitoringDisplayProfile from "./monitoringDisplayProfile/reducer";
import widgetChannelState from "./widgetChannelState/reducer";

export default () =>
  combineReducers({
    account,
    toastr: toastrReducer,
    port,
    connection,
    block,
    channel,
    user,
    monitoring,
    widget,
    widgetChannel,
    widgetState,
    history,
    dashboard,
    jwt,
    setting,
    tagGroup,
    session,
    credential,
    bucket,
    gauge,
    license,
    healthCheck,
    displayProfile,
    monitoringDisplayProfile,
    widgetChannelState,
  });
